import NavigationDetail from '../../Pages/navigationDetail';
import ServiceDetail from '../../Pages/servicesDetail';

const routes = [
  {
    path: "/",
    title: "Ana Sayfa",
    element: "Home"
  },
  {
    path: "/services",
    title: "Services",
    element: "Services"
  },
  // {
  //   path: "/services/:id",
  //   title: "Service Detail",
  //   element: "ServiceDetail"
  // },
  {
    path: "/ports",
    title: "Limanlar",
    element: "Ports"
  },
  {
    path: "/about",
    title: "Hakkımızda",
    element: "About"
  },
  {
    path: "/products/navigation",
    element: "Navigation"
  },
  {
    path: "/products/communication",
    title: "Communication",
    element: "Communication"
  },
  {
    path: "/services", 
    title: "Services",
    element: "Services"
  },
  {
    path: "/contact",
    title: "Contact",
    element: "Contact"
  }
];

export default routes;